import './bootstrap';
import './sw-register';
import Alpine from 'alpinejs';
import HSStaticMethods from 'preline';
import installPrompt from './install-prompt';
import offlineQueue from './pwa/offline-queue';
import participantAnswer from './participant-answer';
import installEchoFallback from './echo-fallback';

// `projector` (and the ECharts library it pulls in) lives in its own entry,
// `resources/js/projector-entry.js`, loaded only by the projector layout.
// Don't reimport it here — it would defeat the code-split.

window.Alpine = Alpine;
window.HSStaticMethods = HSStaticMethods;

Alpine.data('installPrompt', installPrompt);
Alpine.data('offlineQueue', offlineQueue);
Alpine.data('participantAnswer', participantAnswer);

Alpine.start();

// Reverb disconnect fallback for the participant page (no-op elsewhere).
installEchoFallback();

document.addEventListener('DOMContentLoaded', () => {
    HSStaticMethods.autoInit();
});

document.addEventListener('livewire:navigated', () => {
    HSStaticMethods.autoInit();
});

// Read the localized strings exposed by the pwa-meta component (CSP-safe JSON).
function pulsarI18n() {
    try {
        return JSON.parse(document.getElementById('pulsar-i18n')?.textContent || '{}');
    } catch {
        return {};
    }
}

// A new service-worker version took control — the page is still running the
// previous assets until a reload. sw-register.js dispatches this; show a
// dismissible refresh prompt (inline styles so Tailwind's purge can't drop it).
window.addEventListener('pulsar:sw-updated', () => {
    if (document.getElementById('pulsar-update-banner')) {
        return;
    }
    const i18n = pulsarI18n();
    const bar = document.createElement('div');
    bar.id = 'pulsar-update-banner';
    bar.setAttribute('role', 'status');
    bar.style.cssText =
        'position:fixed;left:0;right:0;bottom:0;z-index:9999;display:flex;gap:.75rem;'
        + 'align-items:center;justify-content:center;padding:.75rem 1rem;background:#1e293b;'
        + 'color:#e2e8f0;font:500 14px system-ui,sans-serif';

    const label = document.createElement('span');
    label.textContent = i18n.updateAvailable || 'A new version is available.';

    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = i18n.updateAction || 'Refresh';
    button.style.cssText =
        'background:#6366f1;color:#fff;border:0;border-radius:.5rem;padding:.35rem .9rem;'
        + 'font:inherit;cursor:pointer';
    button.addEventListener('click', () => window.location.reload());

    bar.append(label, button);
    document.body.appendChild(bar);
});

// Centralised client-error logging. No user-facing UI by design — surfacing a
// banner on every benign third-party rejection is noise. This is the hook to
// later forward to Sentry's browser SDK (a separate decision: it adds bundle
// weight to the perf-sensitive participant page).
window.addEventListener('error', (e) => console.error('[pulsar] uncaught error:', e.error || e.message));
window.addEventListener('unhandledrejection', (e) => console.error('[pulsar] unhandled rejection:', e.reason));
